module.exports = __webpack_public_path__ + "img/register.7b8c063b.svg";